module.exports = __webpack_public_path__ + "img/image_13.afb5b159.png";